import KyMethod from "@repositories/KyMethod"

export default class CourseRepositories extends KyMethod {
  async getRawCategories() {
    return this._getPaginationData("/categories")
  }

  async getRawCourses(query?: any) {
    return this._getPaginationData("/courses", query)
  }
}
